import type { ShortcutHandlerContext } from '../../../../../../lib/types.js';
import { handleShortcutFileBrowserRead } from '../../../../../lib/file-browser/handle-read.js';

/** GET /api/sessions/:sessionId/files/read */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  await handleShortcutFileBrowserRead(ctx, ctx.params.sessionId);
}
